export enum UserDealerListRequestOrder {
  FIRST_NAME_ASC = "FIRST_NAME_ASC",
  FIRST_NAME_DESC = "FIRST_NAME_DESC",
  LAST_NAME_ASC = "LAST_NAME_ASC",
  LAST_NAME_DESC = "LAST_NAME_DESC",
  USERNAME_ASC = "USERNAME_ASC",
  USERNAME_DESC = "USERNAME_DESC",
}

export enum UserDealerListRequestStatusCriteria {
  ACTIVE = "ACTIVE",
  DELETED = "DELETED",
  ALL = "ALL",
}

export type UserDealerListRequestQueryParams = {
  taxiCorporation?: string;
  taxiCorporationId?: string;
  firstName?: string;
  lastName?: string;
  username?: string;
  email?: string;
  statusCriteria?: UserDealerListRequestStatusCriteria;
  creationStart?: Date;
  creationEnd?: Date;
  order?: UserDealerListRequestOrder;
  offset?: number;
  limit?: number;
};

type UserDealerListRequest = {
  taxiCorporation?: string;
  taxiCorporationId?: string;
  firstName?: string;
  lastName?: string;
  username?: string;
  email?: string;
  statusCriteria?: UserDealerListRequestStatusCriteria;
  order?: UserDealerListRequestOrder;
  offset?: number;
  limit?: number;
  creationStart?: Date;
  creationEnd?: Date;
};

export default UserDealerListRequest;
